import React from 'react';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useBooking } from '../../modules/booking/BookingContext';

export default function FloatingActionButtons() {
  const location = useLocation();
  const { bookingState } = useBooking();
  const isBookingPage = location.pathname === '/book';

  if (isBookingPage) return null;

  return (
    <div className="floating-action-buttons">
      {/* Mobile View */}
      <div className="mobile-bottom-nav sm:hidden">
        <Link
          to="/book"
          state={bookingState}
          className="mobile-bottom-nav-item text-blue-600"
        >
          <Calendar className="h-6 w-6" />
          <span>Book</span>
        </Link>

        <a
          href="tel:+918559929954"
          className="mobile-bottom-nav-item text-green-600"
        >
          <Phone className="h-6 w-6" />
          <span>Call</span>
        </a>

        <a
          href="https://wa.me/918559940369"
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-bottom-nav-item text-green-600"
        >
          <MessageCircle className="h-6 w-6" />
          <span>WhatsApp</span>
        </a>
      </div>

      {/* Desktop View */}
      <div className="hidden sm:flex flex-col gap-3">
        <Link
          to="/book"
          state={bookingState}
          className="floating-action-button bg-blue-600 hover:bg-blue-700"
        >
          <Calendar className="h-5 w-5 sm:mr-2" />
          <span className="hidden sm:inline">Book Now</span>
        </Link>

        <a
          href="tel:+918559929954"
          className="floating-action-button bg-green-500 hover:bg-green-600"
        >
          <Phone className="h-5 w-5 sm:mr-2" />
          <span className="hidden sm:inline">Call Now</span>
        </a>

        <a
          href="https://wa.me/918559940369"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-action-button bg-green-600 hover:bg-green-700"
        >
          <MessageCircle className="h-5 w-5 sm:mr-2" />
          <span className="hidden sm:inline">WhatsApp</span>
        </a>
      </div>
    </div>
  );
}